export const mapRelationTypeToForm = values =>
  !values
    ? null
    : {
        ...values,
        sourceRestrictions: (values?.sourceRestrictions || []).map(sr => sr.organisationRole?.id),
        targetRestrictions: (values?.targetRestrictions || []).map(tr => tr.organisationRole?.id),
      };
